// Toast po pridaní do košíka — slovenské dvojče locale/cs/cartToast.js.
export default {
  added: 'Pridané do košíka',
  showCart: 'Zobraziť košík',
};
